/* DESKOLITE THEME JS */

document.addEventListener('DOMContentLoaded', function() {

  // ── CURSOR ──
  const cursorEl   = document.getElementById('dsk-cursor');
  const cursorRing = document.getElementById('dsk-cursor-ring');

  // Only activate custom cursor on non-touch devices
  const isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);

  if (cursorEl && cursorRing && !isTouch) {
    // Only hide real cursor AFTER we confirm custom one is ready
    document.body.style.cursor = 'none';
    cursorEl.style.opacity  = '0';
    cursorRing.style.opacity = '0';

    let mx = -100, my = -100, rx = -100, ry = -100;
    let cursorActive = false;

    document.addEventListener('mousemove', e => {
      mx = e.clientX; my = e.clientY;
      cursorEl.style.left    = mx + 'px';
      cursorEl.style.top     = my + 'px';
      if (!cursorActive) {
        cursorActive = true;
        cursorEl.style.opacity   = '1';
        cursorRing.style.opacity = '1';
      }
    });

    // Restore real cursor if mouse leaves the window
    document.addEventListener('mouseleave', () => {
      cursorEl.style.opacity   = '0';
      cursorRing.style.opacity = '0';
      cursorActive = false;
    });
    document.addEventListener('mouseenter', () => {
      if (cursorActive) {
        cursorEl.style.opacity   = '1';
        cursorRing.style.opacity = '1';
      }
    });

    // Smooth ring follow
    (function tick() {
      rx += (mx - rx) * .12;
      ry += (my - ry) * .12;
      cursorRing.style.left = rx + 'px';
      cursorRing.style.top  = ry + 'px';
      requestAnimationFrame(tick);
    })();
  } else {
    // Touch device or elements missing — ensure real cursor is visible
    document.body.style.cursor = 'auto';
    if (cursorEl)   cursorEl.style.display   = 'none';
    if (cursorRing) cursorRing.style.display = 'none';
  }

  // ── HERO COLOR SWITCHER ──
  document.querySelectorAll('.dsk-csw-dot').forEach(dot => {
    dot.addEventListener('click', () => {
      const color = dot.dataset.color;
      const sphere = document.getElementById('dsk-hero-sphere');
      if (!sphere) return;
      document.querySelectorAll('.dsk-csw-dot').forEach(d => d.classList.remove('active'));
      dot.classList.add('active');
      sphere.className = 'dsk-sphere dsk-hero__sphere dsk-s-' + color;
      const beamColor = color === 'pink'   ? 'rgba(244,114,182,.65)' :
                        color === 'chrome' ? 'rgba(220,220,220,.3)'  :
                                             'rgba(123,92,245,.65)';
      document.querySelectorAll('.dsk-beam').forEach(b => {
        b.style.background = 'linear-gradient(to bottom,' + beamColor + ',transparent)';
      });
    });
  });

  // ── PRODUCT TABS ──
  document.querySelectorAll('.dsk-tab-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.tab;
      document.querySelectorAll('.dsk-tab-btn').forEach(b => b.classList.remove('active'));
      document.querySelectorAll('.dsk-tab-pane').forEach(p => p.classList.remove('active'));
      btn.classList.add('active');
      const pane = document.getElementById(target);
      if (pane) pane.classList.add('active');
    });
  });

  // ── ANIMATED TERMINAL ──
  const termLines = document.querySelectorAll('.dsk-terminal-line');
  const msgs = [
    'initializing rgb_engine...',
    'bt_module: <span class="t-g">online</span>',
    'motor_control: <span class="t-g">active</span>',
    'remote_sync: <span class="t-g">paired</span>',
    'stock_status: <span class="t-g">in stock</span>',
    'system_ready <span class="t-g">✓</span>'
  ];
  let tIdx = 0;
  if (termLines.length) {
    setInterval(() => {
      termLines[tIdx % termLines.length].innerHTML =
        '<span class="t-p">></span> ' + msgs[tIdx % msgs.length];
      tIdx++;
    }, 2200);
  }

  // ── MOBILE NAV ──
  // Nav handled by nav.liquid inline script

  // Popup handled by inline script in theme.liquid


  /* ─────────────────────────────────────────
     PRODUCT PAGE — VARIANT SWITCHER
     Switches image + price + variant ID when
     color/option buttons are clicked
  ───────────────────────────────────────── */
  var variantBtns = document.querySelectorAll('.dsk-variant-btn');
  if (variantBtns.length > 0 && window.__variants) {

    var selectedOptions = {};

    // Init selected options from active buttons
    variantBtns.forEach(function(btn) {
      if (btn.classList.contains('active')) {
        selectedOptions[btn.dataset.option] = btn.dataset.value;
      }
    });

    function findVariant() {
      return window.__variants.find(function(v) {
        return v.options.every(function(opt, i) {
          var optName = window.__optionNames[i];
          return selectedOptions[optName] === opt;
        });
      });
    }

    function updateVariant() {
      var variant = findVariant();
      if (!variant) return;

      // Update hidden variant ID input
      var vidInput = document.getElementById('variant-id');
      if (vidInput) vidInput.value = variant.id;

      // Update price display
      var priceEl  = document.querySelector('.dsk-price-now');
      var compareEl = document.querySelector('.dsk-price-was');
      if (priceEl && variant.price) {
        priceEl.textContent = '$' + (variant.price / 100).toFixed(2);
      }
      if (compareEl && variant.compare_at_price) {
        compareEl.textContent = '$' + (variant.compare_at_price / 100).toFixed(2);
      }

      // Update option label em tags
      variantBtns.forEach(function(btn) {
        if (btn.classList.contains('active')) {
          var label = document.querySelector('.dsk-option-label[data-for="' + btn.dataset.option + '"] em');
          if (label) label.textContent = btn.dataset.value;
        }
      });

      // Update main image if variant has a featured image
      if (variant.featured_image) {
        var mainImg = document.getElementById('dsk-gallery-main-img');
        if (mainImg) {
          // Build Shopify CDN URL from image src
          var src = variant.featured_image.src;
          // Replace size parameter for 700x700
          src = src.replace(/(_\d+x\d*|_\d*x\d+)(\.[a-z]+)$/, '_700x700$2');
          mainImg.src = src;
        }
      }

      // Update ATC button availability
      var atcBtn = document.querySelector('.dsk-atc-btn');
      if (atcBtn) {
        if (!variant.available) {
          atcBtn.textContent = 'Sold Out';
          atcBtn.disabled = true;
          atcBtn.style.opacity = '0.5';
        } else {
          atcBtn.textContent = 'Add to Cart';
          atcBtn.disabled = false;
          atcBtn.style.opacity = '1';
        }
      }
    }

    variantBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        // Update active state for this option group
        document.querySelectorAll('.dsk-variant-btn[data-option="' + btn.dataset.option + '"]').forEach(function(b) {
          b.classList.remove('active');
        });
        btn.classList.add('active');
        selectedOptions[btn.dataset.option] = btn.dataset.value;
        updateVariant();
      });
    });
  }

});

/* ═══ SIMULATOR + HAMBURGER — wait for DOM ═══ */
document.addEventListener('DOMContentLoaded', function() {

  /* ─────────────────────────────────────────
     SIMPLE SPINNING BALL SIMULATOR
  ───────────────────────────────────────── */
  var DSK = {
    on: false, color: 'purple', hue: 0, modeTimer: null
  };

  var DSK_COLORS = {
    purple:'#7B5CF5', pink:'#F472B6', green:'#22c55e',
    cyan:'#06b6d4', red:'#ef4444', gold:'#C8A84B', white:'#e5e5e5'
  };

  var lsqsEl = document.getElementById('dsk-sim-lsqs');
  if (!lsqsEl) return; // simulator not on this page

  var sqEls = [];
  for (var i = 0; i < 55; i++) {
    var sq = document.createElement('div');
    sq.className = 'dsk-sim-lsq';
    sq.style.width  = (7  + Math.random()*16) + 'px';
    sq.style.height = (5  + Math.random()*12) + 'px';
    sq.style.setProperty('--r',     (Math.random()*24-12)   + 'deg');
    sq.style.setProperty('--tx',    (Math.random()*20-10)   + 'px');
    sq.style.setProperty('--ty',    (Math.random()*20-10)   + 'px');
    sq.style.setProperty('--pk',    (0.15+Math.random()*.55).toString());
    sq.style.setProperty('--dur',   (2   + Math.random()*5) + 's');
    sq.style.setProperty('--delay', (Math.random()*8)       + 's');
    // keep squares on edges only — not over the ball
    var zone = i % 4;
    if (zone === 0) { sq.style.left=(2+Math.random()*20)+'%'; sq.style.top=(2+Math.random()*90)+'%'; }
    else if (zone === 1) { sq.style.left=(70+Math.random()*25)+'%'; sq.style.top=(2+Math.random()*90)+'%'; }
    else if (zone === 2) { sq.style.left=(20+Math.random()*55)+'%'; sq.style.top=(2+Math.random()*18)+'%'; }
    else { sq.style.left=(20+Math.random()*55)+'%'; sq.style.top=(78+Math.random()*18)+'%'; }
    sq.style.animationPlayState = 'paused';
    lsqsEl.appendChild(sq);
    sqEls.push(sq);
  }

  function hexToRgb(hex) {
    var r=parseInt(hex.slice(1,3),16), g=parseInt(hex.slice(3,5),16), b=parseInt(hex.slice(5,7),16);
    return r+','+g+','+b;
  }

  function dskApplyColor() {
    var hex = DSK.color === 'rainbow' ? '#7B5CF5' : DSK_COLORS[DSK.color];
    var spin = document.getElementById('dsk-sim-spin');
    var bg   = document.getElementById('dsk-sim-bg');
    var glow = document.getElementById('dsk-sim-glow');
    if (!spin) return;
    if (DSK.color === 'rainbow') {
      spin.style.background = 'conic-gradient(hsl('+DSK.hue+',90%,55%),hsl('+(DSK.hue+60)+',90%,50%),hsl('+(DSK.hue+120)+',90%,55%),hsl('+(DSK.hue+180)+',90%,50%),hsl('+(DSK.hue+240)+',90%,55%),hsl('+(DSK.hue+300)+',90%,50%),hsl('+DSK.hue+',90%,55%))';
    } else {
      var c = hexToRgb(hex);
      spin.style.background = 'conic-gradient(rgba('+c+',0) 0deg,rgba('+c+',.9) 30deg,rgba('+c+',0) 60deg,rgba('+c+',.7) 90deg,rgba('+c+',0) 120deg,rgba('+c+',.9) 150deg,rgba('+c+',0) 180deg,rgba('+c+',.7) 210deg,rgba('+c+',0) 240deg,rgba('+c+',.9) 270deg,rgba('+c+',0) 300deg,rgba('+c+',.7) 330deg,rgba('+c+',0) 360deg)';
    }
    if (bg)   bg.style.background   = 'radial-gradient(ellipse 100% 100% at 50% 40%,'+hex+'18 0%,transparent 70%)';
    if (glow) glow.style.background = 'radial-gradient(circle,'+hex+'44 0%,transparent 65%)';
    sqEls.forEach(function(sq){ sq.style.background=hex; sq.style.boxShadow='0 0 7px 2px '+hex; });
  }

  window.dskSimPower = function() {
    DSK.on = !DSK.on;
    var pw   = document.getElementById('dsk-sim-pw');
    var room = document.getElementById('featuresSim');
    if (pw)   pw.classList.toggle('on', DSK.on);
    if (room) room.classList.toggle('dsk-sim-on', DSK.on);
    if (DSK.on) {
      dskApplyColor();
      lsqsEl.style.opacity = '1';
      sqEls.forEach(function(sq){ sq.style.animationPlayState='running'; });
      if (DSK.color === 'rainbow') dskStartRainbow();
    } else {
      lsqsEl.style.opacity = '0';
      sqEls.forEach(function(sq){ sq.style.animationPlayState='paused'; });
      clearInterval(DSK.modeTimer);
      var bg   = document.getElementById('dsk-sim-bg');
      var glow = document.getElementById('dsk-sim-glow');
      if (bg)   bg.style.background   = '';
      if (glow) glow.style.background = '';
    }
  };

  window.dskSimColor = function(color, btn) {
    DSK.color = color;
    document.querySelectorAll('.dsk-sim-cc').forEach(function(b){ b.classList.remove('active'); });
    btn.classList.add('active');
    clearInterval(DSK.modeTimer);
    if (DSK.on) {
      dskApplyColor();
      if (color === 'rainbow') dskStartRainbow();
    }
  };

  function dskStartRainbow() {
    clearInterval(DSK.modeTimer);
    DSK.modeTimer = setInterval(function(){
      DSK.hue = (DSK.hue + 2) % 360;
      dskApplyColor();
    }, 40);
  }

  /* hamburger handled inline in nav.liquid */

});


/* ═══════════════════════════════════════════
   STICKY ATC — show after scrolling past main ATC
═══════════════════════════════════════════ */
(function() {
  var stickyBar = document.getElementById('dsk-sticky-atc');
  var mainAtc   = document.querySelector('.dsk-atc-btn');
  if (!stickyBar || !mainAtc) return;

  function checkScroll() {
    var rect = mainAtc.getBoundingClientRect();
    // Show sticky bar when main ATC button scrolls out of view
    if (rect.bottom < 0) {
      stickyBar.style.display = 'flex';
    } else {
      stickyBar.style.display = 'none';
    }
  }
  window.addEventListener('scroll', checkScroll, { passive: true });
  checkScroll();

  // Keep sticky price in sync with variant switcher
  var stickyPrice = document.getElementById('dsk-sticky-price');
  if (stickyPrice) {
    document.querySelectorAll('.dsk-variant-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var priceEl = document.querySelector('.dsk-price-now');
        if (priceEl && stickyPrice) stickyPrice.textContent = priceEl.textContent;
      });
    });
  }
})();

/* ═══════════════════════════════════════════
   LIVE VIEWERS COUNTER — random fluctuation
═══════════════════════════════════════════ */
(function() {
  var el = document.getElementById('dsk-viewers-text');
  if (!el) return;
  var count = Math.floor(Math.random() * 20) + 15; // 15-35
  function update() {
    var delta = Math.floor(Math.random() * 5) - 2; // -2 to +2
    count = Math.max(8, Math.min(60, count + delta));
    el.innerHTML = '<strong>' + count + '</strong> people viewing now';
    setTimeout(update, Math.floor(Math.random() * 8000) + 4000); // every 4-12s
  }
  update();
})();

/* ── CART COUNT — update bubble after add to cart ── */
function dskUpdateCartCount() {
  fetch('/cart.js')
    .then(function(r){ return r.json(); })
    .then(function(cart) {
      var count = cart.item_count || 0;
      document.querySelectorAll('.dsk-cart-count').forEach(function(el) {
        el.textContent = count;
        el.style.display = count > 0 ? 'flex' : 'none';
      });
    })
    .catch(function(){});
}

// Update count on page load
document.addEventListener('DOMContentLoaded', dskUpdateCartCount);

// Intercept all add-to-cart form submits to update count
document.addEventListener('submit', function(e) {
  var form = e.target;
  if (form && (form.id === 'product-form' || form.id === 'product-form-dynamic' || form.id === 'dsk-lp-form')) {
    // Let form submit normally, then update count after navigation
    // Cart count will update on next page load
  }
});
